<template>
<div class="col-12 col-md-3 col-xl-2 sidebar bg-dark shadow-sm d-none d-md-flex">
  <div class="pt-2 w-100">
    <div class="logo">
      <router-link to="/">
        <fa-icon icon="phone-volume" /> <strong>АТС</strong>
      </router-link>
    </div>
    
    <b-nav class="left-nav flex-column flex-nowrap d-flex">
      <b-nav-item v-if="project" class="mt-2" disabled>
        <span class="lead">{{ project.name }}</span>
      </b-nav-item>
      <b-nav-item v-if="project" :to="{name: 'project-main', params: {projectId: project.id}}">
        <fa-icon icon="th" fixed-width /> Обзор
      </b-nav-item>
      <b-nav-item v-if="project" activeClass="router-link-exact-active"
        :to="{name: 'statistics-overview', params: {projectId: project.id}}">
        <fa-icon icon="chart-pie" fixed-width /> Статистика
      </b-nav-item>
      <b-nav-item v-if="project" :to="{name: 'call-list', params: {projectId: project.id}}">
        <fa-icon icon="list" fixed-width /> Звонки
      </b-nav-item>
      <b-nav-item v-if="project" :to="{name: 'phone-list', params: {projectId: project.id}}">
        <fa-icon icon="phone-alt" fixed-width /> Номера
      </b-nav-item>
      <!-- <li class="nav-item" v-if="project">
           <b-link class="nav-link">
           <fa-icon icon="users-cog" fixed-width /> Пользователи
           </b-link>
           <b-nav class="left-second-nav flex-column">
           <b-nav-item>Настройки</b-nav-item>
           <b-nav-item>Настройки</b-nav-item>
           <b-nav-item>Настройки</b-nav-item>
           </b-nav>
           </li> -->
      <li class="nav-item" v-if="project">
        <b-link class="nav-link" :to="{name: 'project-edit', params: {projectId: project.id}}">
          <fa-icon icon="cog" fixed-width /> Настройки
        </b-link>
      </li>

      <li class="nav-item" v-if="project">
        <hr />
      </li>
      <!-- Site-wide items -->

      <b-nav-item v-if="!project" :to="{name: 'main'}" class="mt-2">
        <fa-icon icon="th-large" fixed-width /> Главная
      </b-nav-item>
      <b-nav-item v-if="!project" :to="{name: 'project-list'}">
        <fa-icon icon="th-list" fixed-width /> Управление проектами
      </b-nav-item>
      <!-- <b-nav-item>
           <fa-icon icon="users-cog" fixed-width /> Пользователи
           </b-nav-item> -->

    </b-nav>
  </div>
</div>
</template>

<script>
import { store } from "@/store";

export default {
    name: 'LeftNav',
    data () {
        return {
            appState: store.state
        };
    },
    computed: {
        project () {
            return this.appState.currentProject;
        }
    }
}
</script>

<style scoped lang="scss">
.sidebar {
    z-index: 1000;
    min-height: 100vh;
    
    > div {
        position: sticky;
        top: 0;
    }
}

.logo {
    Padding: 0 1rem;
    color: white;
    font-size: 2rem;
    
    a {
        color: white;
        text-decoration: none;
    }
}

.left-nav {
    border-top: 1px solid #414850;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 5rem);

    a.nav-link {
        color: white;

        &.router-link-exact-active {
            font-weight: bold;
        }
    }
}

.left-second-nav {
    margin: 0 0 1rem;
    padding-left: 1.75em;

    a.nav-link {
        color: lightgray;
        font-size: 90%;
    }
}
</style>

